import { render, staticRenderFns } from "./justificationIndex.vue?vue&type=template&id=5215ccef&"
import script from "./justificationIndex.vue?vue&type=script&lang=js&"
export * from "./justificationIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports